import { ArchitectureHealthPanel } from "@/components/ArchitectureHealthPanel";

export default function ArchitectureHealth() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold">Architecture Health</h1>
        <p className="text-sm text-muted-foreground">System integrity, module boundaries, and execution flow</p>
      </div>
      <ArchitectureHealthPanel />
    </div>
  );
}
